export const DEMO_BASE_IMAGE = "/hair-demo/base.webp";

export const DEMO_SHADES = [
  { id: "icy-platinum", name: "Icy Platinum", hex: "#E8E4D8", src: "/hair-demo/platinum.webp" },
  { id: "honey-balayage", name: "Honey Balayage", hex: "#946A38", src: "/hair-demo/balayage.webp" },
  { id: "copper-red", name: "Copper Red", hex: "#B5622A", src: "/hair-demo/copper.webp" },
  { id: "jet-black", name: "Jet Black", hex: "#0A0A0A", src: "/hair-demo/black.webp" },
  { id: "pure-silver", name: "Pure Silver", hex: "#C7C9CC", src: "/hair-demo/silver.webp" },
  { id: "pastel-pink", name: "Pastel Pink", hex: "#F4C2D0", src: "/hair-demo/pink.webp" },
] as const;
